import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchTables, saveReservation, UpdateReservation } from "../../redux/action";
import "./ReservationForm.css";

// 🌟 FIXED: Destructured 'onSuccess' prop from parent
function ReservationForm({ edit }) {
  const dispatch = useDispatch();
  const { tables, loading, error } = useSelector((state) => state.admin);
  const reservationSaving = useSelector((state) => Boolean(state.admin?.reservationSaving));
  const [formData, setFormData] = useState({
    customerName: "",
    mobileNumber: "",
    reservationDate: "",
    reservationTime: "",
    numberOfGuests: "",
    restaurantTableId: "",
    reservationAmount: "",
    status: ""
  });
  const submitLock = useRef(false);

  useEffect(() => {
    if (!reservationSaving) submitLock.current = false;
  }, [reservationSaving]);

  useEffect(() => {
    if (edit) {
      setFormData(edit);
    } else {
      setFormData({
        customerName: "",
        mobileNumber: "",
        reservationDate: "",
        reservationTime: "",
        numberOfGuests: "",
        restaurantTableId: "",
        reservationAmount: "",
        status: ""
      });
    }
  }, [edit]);

  const status = ["Booked", "CheckedIn", "Completed", "Cancelled"];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (reservationSaving || submitLock.current) return;
    submitLock.current = true;

    const payload = {
      reservationId: formData.reservationId,
      customerName: formData.customerName,
      mobileNumber: formData.mobileNumber,
      reservationDate: formData.reservationDate,
      reservationTime: formData.reservationTime.substring(0, 5) + ":00",
      numberOfGuests: Number(formData.numberOfGuests),
      reservationAmount: Number(formData.reservationAmount),
      restaurantOrBranchId: formData.restaurantOrBranchId,
      restaurantTableId: formData.restaurantTableId,
      status: formData.status
    };

    console.log("Reservation saved:", payload);

    if (edit?.reservationId) {
      dispatch(UpdateReservation(payload));
    } else {
      dispatch(saveReservation(payload));
    }

  };

  useEffect(() => {
    dispatch(fetchTables());
  }, [dispatch]);

  return (
    <form id="reservation-form" onSubmit={handleSubmit} style={{ display: "grid", gap: "12px" }}>
      <input name="customerName" placeholder="Customer Name" value={formData.customerName} onChange={handleChange} required />
      <input name="mobileNumber" placeholder="Mobile Number" value={formData.mobileNumber} onChange={handleChange} required />
      <legend className="grouped-inputs date-time" legend="Reservation Date & Time">
        <input type="date" name="reservationDate" value={formData.reservationDate ? formData.reservationDate.split("T")[0] : ""} onChange={handleChange} required />
        <input type="time" name="reservationTime" value={formData.reservationTime} onChange={handleChange} required />
      </legend>
      <legend className="grouped-inputs" legend="Guests & Amount">
        <input type="number" name="numberOfGuests" placeholder="Guests" value={formData.numberOfGuests} onChange={handleChange} required />
        <input type="number" name="reservationAmount" placeholder="Booking Amount" value={formData.reservationAmount} onChange={handleChange} min={0} />
      </legend>
      <legend className="grouped-inputs" legend="Table & Status">
        <select
          name="restaurantTableId"
          className="table-select"
          value={formData.restaurantTableId}
          onChange={handleChange}
          required
        >
          <option value="">Select Table</option>
          {loading ? (
            <option>Loading tables...</option>
          ) : (
            tables?.map((table) => (
              <option key={table.restaurantTableId} value={table.restaurantTableId}>
                T-{table.tableName}   (Seats {table.capacity || 0})
              </option>
            ))
          )}
        </select>

        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          className="table-select"
        >
          <option value="">Select Status</option>
          {status.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
        </select>
      </legend>
    </form>
  );
}

export default ReservationForm;
